import FolderCard from './folderCard';

import useGetFolders from '../../hooks/useGetFolders';

import { ReactComponent as NoFolders } from 'assets/icons/Nofolders.svg';
import PrimaryButton from 'components/primaryButton';
import AddNewFolderModal from './addnewfolderModal';
import { useState } from 'react';
import FolderCardLoader from './folderCardLoader';

const ActiveFolder = ({ searchFilter, yearFilter, monthFilter }) => {
  const foldersData = useGetFolders(
    null,
    searchFilter,
    yearFilter,
    monthFilter
  );

  const [newFolderModal, setNewFolderModal] = useState(false);

  return (
    <>
      {foldersData?.isLoading ? (
        <div className='mt-4 px-2 grid grid-cols-3 gap-5'>
          <FolderCardLoader />
        </div>
      ) : (
        <>
          {foldersData?.data?.data?.length === 0 ? (
            <div className='mt-4 px-2 flex justify-center items-center min-h-[60vh] max-h-[60vh] flex-col gap-3'>
              <NoFolders />
              <p className='text-[#535353]'>
                Seems like you don’t have any folders to show
              </p>
              <button onClick={() => setNewFolderModal(true)}>
                <PrimaryButton>+ New Folder</PrimaryButton>
              </button>
            </div>
          ) : (
            <div className='mt-4 px-2 grid grid-cols-3 gap-5'>
              {foldersData?.data?.data?.map((eachFolder) => (
                <div key={eachFolder?.id}>
                  <FolderCard folder={eachFolder} />
                </div>
              ))}
            </div>
          )}
        </>
      )}
      <AddNewFolderModal
        newFolderModal={newFolderModal}
        setNewFolderModal={setNewFolderModal}
      />
    </>
  );
};

export default ActiveFolder;
